import { render, staticRenderFns } from "./TicketNote.vue?vue&type=template&id=67322a12&scoped=true&"
import script from "./TicketNote.vue?vue&type=script&lang=js&"
export * from "./TicketNote.vue?vue&type=script&lang=js&"
import style0 from "./TicketNote.vue?vue&type=style&index=0&id=67322a12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67322a12",
  null
  
)

export default component.exports